module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABR0lEQVQ4T6WTvWvCUBTFzyXpGiM4B9wyieD/ICGLg+KSRQhC1jari2OWdHUJGQV3HXUWQ2YFV6fg4Gis3vKkDUg/krRvfJzze7xz76FKpeIR0TMRPaHEYeYLM7+SqqoXIpJLeDMpM79RtVrlv5g/PRmAiDAej9HtdtHpdLDf7wtxM0C/38dkMrmb4jhGu93G7XbLhWSA4XAIz/MyQ6/Xw3K5LA7QNA1RFEGWZZzPZzQaDSRJUhwglL7vYzAY4Hq9wjRNbDabcgBFUbBarVCv1++vizC32+2vkC9j1HUdi8UCqqridDphOp3CMAys12uMRiMcj8cH4Ld70Gw2MZvNUKvVHsSHwwEi3N1ul93/uEgi1CAI0Gq1HiCu6yIMw3yAUEiSBMuyYNs2xNfm8zkcx0GapsUAuSMA8N8yXeijzi9lGymayMz+O5vSgSqJeSCPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/about_mobile/12.png
// module id = hz9j
// module chunks = 1